/* eslint-disable max-params */
/* eslint-disable complexity */
import "./index.less";
import { Schedule } from "@/api/calendar";
import dayjs, { Dayjs } from "dayjs";
import { throttle } from "lodash";
import { DragState, DragType, DragViewType } from "../../Enums";
import { addClass, hasClass, removeClass } from "../../utils/handleClass";

export interface mouseDownProps {
  event: any;
  dataRef: any;
  scrollRef: any;
  container: any;
  dragType: number;
  current?: Dayjs;
  curMoveSchedule?: Schedule | null;
  dragDom?: any;
}
export interface mouseMoveProps {
  event: any;
  dataRef: any;
  scrollRef: any;
  dragView: string;
  updateDragTime: Function;
}
export interface MouseUpProps {
  event: any;
  dataRef: any;
  dragView: string;
  updateDragTime: Function;
  setQuickCreateModalVisible?: Function;
  throttleHandleDragElementResize?: any;
}

export interface scrollFrameProps {
  event: any;
  dataRef: any;
  scrollRef: any;
  updateDragTime: Function;
}

// 阻止系统默认的操作来防止触发浏览器的 drag 操作
export const pauseEvent = (e: any) => {
  if (e.stopPropagation) e.stopPropagation();
  if (e.preventDefault) e.preventDefault();
  e.cancelBubble = true;
  e.returnValue = false;
};

// 通过按下的区域判定即将拖拽的类型
export const handleMouseDownFun = (opts: mouseDownProps) => {
  const {
    event,
    dataRef,
    scrollRef,
    container,
    dragType,
    current,
    curMoveSchedule,
    dragDom
  } = opts;
  dataRef.current.container = container;
  dataRef.current.containerHeight = container?.offsetHeight || 0;
  dataRef.current.originCilentHeight = scrollRef.current.getClientHeight();
  dataRef.current.originScrollHeight = scrollRef.current.getScrollHeight();
  dataRef.current.curDragType = dragType;
  dataRef.current.curMoveSchedule = curMoveSchedule || null;
  dataRef.current.dragDom = dragDom || "";

  let containerRect: any = container.getBoundingClientRect();
  dataRef.current.commonOffsetTop = containerRect?.y + dataRef.current.scrollTop;
  let minHeight = container?.offsetHeight / 24 / 2;
  let minUnitHeight = container?.offsetHeight / 24 / 4;
  dataRef.current.minHeight = minHeight;
  dataRef.current.minUnitHeight = minUnitHeight;
  dataRef.current.isMouseDown = true;
  let dragStartTop = event.clientY + dataRef.current.scrollTop - dataRef.current.commonOffsetTop;
  dataRef.current.originScrollTop = dataRef.current.scrollTop;
  // 起始点半个小时精度用这个
  // let remainder = dragStartTop % minHeight;
  // 起始点15分钟精度用这个
  let remainder = dragStartTop % minUnitHeight;
  if (remainder > 0) {
    dragStartTop = dragStartTop - remainder;
  }
  if (dragStartTop > container?.offsetHeight - minHeight) {
    dragStartTop = container?.offsetHeight - minHeight;
  }
  dataRef.current.dragStartTop = dragStartTop;
  dataRef.current.mouseY = event.clientY;
  if (dragType === DragType.DRAGTIMEBLOCKEDIT || dragType === DragType.DRAGBORDEREDIT) {
    let dragDomRect: any = dragDom.getBoundingClientRect();
    dataRef.current.dragStartY =
      event.clientY + dataRef.current.scrollTop - dataRef.current.commonOffsetTop;
    dataRef.current.dragBorderStartTop =
      dragDomRect?.top + dataRef.current.scrollTop - dataRef.current.commonOffsetTop;
    dataRef.current.dragBorderStartBottom =
      dragDomRect?.bottom + dataRef.current.scrollTop - dataRef.current.commonOffsetTop;
    let domRect: any = dragDom?.getBoundingClientRect();
    dataRef.current.dragDivHeight = domRect?.height;
  }
  if (current) {
    dataRef.current.curDayStartTime = dayjs(dayjs(current.format("YYYY-MM-DD")).valueOf());
  }
};
// 拖拽分为 1 拖拽创建 dragCreate 2 dragBlockEdit 3 dragBorderEdit
export const handleMouseMoveFun = (opts: mouseMoveProps) => {
  const { event, dataRef, scrollRef, dragView, updateDragTime } = opts;
  if (!dataRef.current.isMouseDown) return;
  dataRef.current.mouseY = event.clientY;
  let {
    minHeight,
    container,
    containerHeight,
    originScrollHeight,
    originCilentHeight
  } = dataRef.current;
  // event = event || window.event; // 解决浏览器兼容问题
  // 距离顶部20px的时候开始上滚动 每50ms滚动30px
  if (!dataRef.current.scrollUpTimer && event.clientY <= dataRef.current.commonOffsetTop + 20) {
    dataRef.current.scrollUpTimer = setInterval(() => {
      let curScrollTop = dataRef.current.scrollTop;
      let newScrollTop = curScrollTop - 30;
      if (newScrollTop < 0) newScrollTop = 0;
      scrollRef.current.scrollTop(newScrollTop);
      dataRef.current.scrollTop = newScrollTop;
    }, 50);
  }
  // 距离底部20px的时候开始上滚动 每50ms滚动30px
  if (!dataRef.current.scrollDownTimer && event.clientY >= window.innerHeight - 20) {
    dataRef.current.scrollDownTimer = setInterval(() => {
      let curScrollTop = dataRef.current.scrollTop;
      let newScrollTop = curScrollTop + 30;
      if (newScrollTop >= originScrollHeight - originCilentHeight) {
        newScrollTop = originScrollHeight - originCilentHeight;
      }

      if (newScrollTop > curScrollTop - scrollRef.current.clientHeight) {
        newScrollTop = scrollRef.current.scrollHeight - scrollRef.current.clientHeight;
      }
      scrollRef.current.scrollTop(newScrollTop);
      dataRef.current.scrollTop = newScrollTop;
    }, 50);
  }
  if (
    event.clientY > dataRef.current.commonOffsetTop + 20 &&
    event.clientY < window.innerHeight - 20 &&
    (dataRef.current.scrollUpTimer || dataRef.current.scrollDownTimer)
  ) {
    clearInterval(dataRef.current.scrollUpTimer);
    clearInterval(dataRef.current.scrollDownTimer);
    dataRef.current.scrollUpTimer = null;
    dataRef.current.scrollDownTimer = null;
  }
  if (dataRef.current.curDragType === DragType.DRAGBLOCKEDIT && dataRef.current.dragDom) {
    // 拖拽编辑
    const dragDom: any = dataRef.current.dragDom;
    let dragBlockBox = container?.querySelector("#drag-block-box");
    const containerRect = container?.getBoundingClientRect();
    if (dragBlockBox) {
      const dragBlockBoxRect = dragBlockBox?.getBoundingClientRect();
      let yTop = event.clientY + dataRef.current.scrollTop - dataRef.current.commonOffsetTop;
      if (event.clientY < dataRef.current.commonOffsetTop) {
        dragBlockBox.style.top = dataRef.current.scrollTop + "px";
      } else if (event.clientY + dragBlockBoxRect.height > window.innerHeight) {
        // 拖到底了
        dragBlockBox.style.top =
          window.innerHeight -
          dragBlockBoxRect.height +
          dataRef.current.scrollTop -
          dataRef.current.commonOffsetTop +
          "px";
      } else {
        dragBlockBox.style.top = yTop + "px";
      }
      if (dragView === DragViewType.WEEK) {
        // 如果left超出左边界 则不能在往左拖动 如果right超出右边界 则不能在往右拖动
        const xLeft = event.clientX - container?.getBoundingClientRect().x;
        if (xLeft < 65) {
          // 拖到最左侧了
          dragBlockBox.style.left = 65 + "px";
        } else if (
          xLeft + dragBlockBoxRect.width + container?.getBoundingClientRect().x >
          window.innerWidth
        ) {
          // 拖到最右侧了
          dragBlockBox.style.left =
            window.innerWidth -
            dragBlockBoxRect.width -
            container?.getBoundingClientRect().x +
            "px";
        } else {
          dragBlockBox.style.left = xLeft + "px";
        }
      }
      dragBlockBox.style.opacity = "1";
      updateDragTime(event, DragState.MOVE, DragType.DRAGBLOCKEDIT, dragBlockBox);
    } else {
      const newEl = dragDom?.cloneNode(true);
      if (dragView === DragViewType.WEEK) {
        newEl.style.width = Math.ceil((containerRect?.width - 65) / 7) + "px";
        newEl.style.left = dragDom?.getBoundingClientRect().x - containerRect?.x + "px";
      } else {
        newEl.style.width = "calc(100% - 65px)";
        newEl.style.left = "65px";
      }
      newEl.style.height = dragDom?.offsetHeight + "px";
      newEl.style.opacity = "0";
      newEl.style.background = "#4DA6FF";
      newEl.id = "drag-block-box";
      removeClass(newEl, "schedule-timepast");
      container.appendChild(newEl);
      updateDragTime(event, DragState.MOVE, DragType.DRAGBLOCKEDIT, dragBlockBox);
    }
    if (!hasClass(dragDom, "drag-move-bg")) {
      addClass(dragDom, "drag-move-bg");
    }
  } else if (
    dataRef.current.curDragType === DragType.DRAGTIMEBLOCKEDIT &&
    dataRef.current.dragDom
  ) {
    // 拖拽编辑
    let dragBlockBox = container?.querySelector("#drag-block-box");
    if (dragBlockBox) {
      // 计算拖动整体块移动时 位置相对变化了多少 向上updateY是正数 向下updateY是负数
      const updateY =
        dataRef.current.dragStartY -
        (event.clientY + dataRef.current.scrollTop - dataRef.current.commonOffsetTop);
      let yTop = dataRef.current.dragBorderStartTop - updateY;
      if (yTop < 0) {
        dragBlockBox.style.top = "0px";
      } else if (yTop + dataRef.current.dragDivHeight > containerHeight) {
        // 拖到底了
        dragBlockBox.style.top = containerHeight - dataRef.current.dragDivHeight + "px";
      } else {
        dragBlockBox.style.top = yTop + "px";
      }
      dragBlockBox.style.bottom = "";
      dragBlockBox.style.opacity = "1";
      updateDragTime(event, DragState.MOVE, DragType.DRAGTIMEBLOCKEDIT, dragBlockBox);
    }
  } else if (dataRef.current.curDragType === DragType.DRAGBORDEREDIT && dataRef.current.dragDom) {
    // 拖拽编辑
    const dragDom: any = dataRef.current.dragDom;
    // 拖动分为拖动上边缘 拖动下边缘两大类
    // 拖上边缘又分为拖动上边缘向上不超过顶部 拖动上边缘向下不超过(top - bottom>=minHeight)最小高
    // 拖下边缘又分为拖动下边缘向下不超过底部 拖动下边缘向上不超过(top - bottom>=minHeight)最小高
    // 计算拖动方向
    let underOrigin =
      dataRef.current.dragStartTop <=
      event.clientY + dataRef.current.scrollTop - dataRef.current.commonOffsetTop;
    dataRef.current.isUnderOrigin = underOrigin;
    // 拖动上边缘 bottom不变height变
    if (dataRef.current.dragBorder === "top") {
      // 上是正数 下是负数
      let newHeight =
        dataRef.current.dragBorderStartBottom -
        (event.clientY + dataRef.current.scrollTop - dataRef.current.commonOffsetTop || 0);
      if (newHeight > dataRef.current.dragBorderStartBottom) {
        newHeight = dataRef.current.dragBorderStartBottom;
      }
      newHeight = newHeight <= minHeight ? minHeight : newHeight;
      dragDom.style.height = newHeight + "px";
      dragDom.style.top = "";
      dragDom.style.bottom = containerHeight - dataRef.current.dragBorderStartBottom + "px";
    }
    // 拖动下边缘 top不变height变
    if (dataRef.current.dragBorder === "bottom") {
      // 上是负数 下是正数
      let newHeight =
        event.clientY +
        dataRef.current.scrollTop -
        dataRef.current.commonOffsetTop -
        dataRef.current.dragBorderStartTop;
      if (newHeight > containerHeight - dataRef.current.dragBorderStartTop) {
        newHeight = containerHeight - dataRef.current.dragBorderStartTop;
      }
      newHeight = newHeight <= minHeight ? minHeight : newHeight;
      dragDom.style.height = newHeight + "px";
      dragDom.style.top = dataRef.current.dragBorderStartTop + "px";
      dragDom.style.bottom = "";
    }
    updateDragTime(event, DragState.MOVE, DragType.DRAGBORDEREDIT, dragDom);
  } else if (dataRef.current.curDragType === DragType.DRAGCREATE) {
    let dragBox = document.getElementById("drag-box");
    if (dragBox) {
      // 改变拖拽div的高以及方向
      let underOrigin =
        dataRef.current.dragStartTop <=
        event.clientY + dataRef.current.scrollTop - dataRef.current.commonOffsetTop;
      dataRef.current.isUnderOrigin = underOrigin;
      let newHeight = dataRef.current.dragDivHeight;
      newHeight = underOrigin
        ? event.clientY +
          dataRef.current.scrollTop -
          dataRef.current.commonOffsetTop -
          dataRef.current.dragStartTop
        : dataRef.current.dragStartTop +
          minHeight -
          event.clientY -
          dataRef.current.scrollTop +
          dataRef.current.commonOffsetTop;
      newHeight = newHeight <= minHeight ? minHeight : newHeight;
      if (underOrigin && newHeight + dataRef.current.dragStartTop >= containerHeight) {
        newHeight = containerHeight - dataRef.current.dragStartTop;
      }
      if (!underOrigin && newHeight >= dataRef.current.dragStartTop + minHeight) {
        newHeight = dataRef.current.dragStartTop + minHeight;
      }
      dataRef.current.dragDivHeight = newHeight;
      dragBox.style.height = newHeight + "px";
      if (!underOrigin) {
        dragBox.style.top = "";
        dragBox.style.bottom = containerHeight - dataRef.current.dragStartTop - minHeight + "px";
      } else {
        dragBox.style.top = dataRef.current.dragStartTop + "px";
        dragBox.style.bottom = "";
      }
      updateDragTime(event, DragState.MOVE, DragType.DRAGCREATE, dragBox);
    } else {
      // 创建拖拽div
      let div = document.createElement("div");
      if (dragView === DragViewType.WEEK) {
        div.style.width = "calc(100% - 4px)";
        div.style.left = "2px";
      }
      div.style.height = minHeight + "px";
      div.style.top = dataRef.current.dragStartTop + "px";
      div.id = "drag-box";
      div.style.cursor = "row-resize";
      // 将创建的div添加到容器中
      container.appendChild(div);
      dataRef.current.dragDivHeight = minHeight;
      updateDragTime(event, DragState.MOVE, DragType.DRAGCREATE, dragBox);
      if (!document.getElementById("drag-silk")) {
        let silk = document.createElement("div");
        silk.id = "drag-silk";
        container?.appendChild(silk);
      }
    }
  }
};
export const elStopPropagation = (el: any) => {
  el.onclick = (e: any) => {
    e.stopPropagation();
  };
  el.ondblclick = (e: any) => {
    e.stopPropagation();
  };
};

export const handleMouseUpFun = (opts: MouseUpProps) => {
  const {
    event,
    dataRef,
    dragView,
    updateDragTime,
    setQuickCreateModalVisible,
    throttleHandleDragElementResize
  } = opts;
  if (dataRef.current.scrollUpTimer || dataRef.current.scrollDownTimer) {
    clearInterval(dataRef.current.scrollUpTimer);
    clearInterval(dataRef.current.scrollDownTimer);
    dataRef.current.scrollUpTimer = null;
    dataRef.current.scrollDownTimer = null;
  }
  let silk: any = document.getElementById("drag-silk");
  if (silk) {
    silk?.parentNode?.removeChild(silk);
  }
  let dragBox: any = document.getElementById("drag-box");
  if (dragBox) {
    dragBox.style.cursor = "default";
    elStopPropagation(dragBox);
  }
  let dragBlockBox = document.getElementById("drag-block-box");
  if (dragBlockBox) {
    elStopPropagation(dragBlockBox);
  }
  let mask = document.getElementById("drag-mask");
  dataRef.current.isMouseDown = false;
  if (!mask && (dragBox || dragBlockBox)) {
    const { container, dragDom } = dataRef.current;
    let body = document.body;
    let mask = document.createElement("div");
    mask.id = "drag-mask";
    mask.onclick = (e) => {
      e.stopPropagation();
      mask?.parentNode?.removeChild(mask);
      dragBox?.parentNode?.removeChild(dragBox);
      dragBlockBox?.parentNode?.removeChild(dragBlockBox);
      if (dragDom) {
        removeClass(dragDom, "drag-move-bg");
      }
      dataRef.current.dragDom = null;
      setQuickCreateModalVisible?.(0);
      dataRef.current.curDragType = DragType.DRAGCREATE;
      dataRef.current.curMoveSchedule = null;
      dataRef.current.dragDivHeight = 0;
      if (dragView === DragViewType.WEEK) {
        dataRef.current.curDayIdx = -1;
        dataRef.current.dragBlockBoxForScheduleViewRatio = 0;
      }
      if (throttleHandleDragElementResize) {
        window.removeEventListener("resize", throttleHandleDragElementResize);
      }
    };
    if (throttleHandleDragElementResize) {
      const scheduleView: any = document.getElementById(
        "calendar-weekview-container-content-scheduleView"
      );
      if (dragBlockBox && scheduleView) {
        dataRef.current.dragBlockBoxForScheduleViewRatio =
          (dragBlockBox?.offsetLeft - 65) / scheduleView?.offsetWidth;
      }
      window.addEventListener("resize", throttleHandleDragElementResize);
    }
    body.appendChild(mask);
    if (dragBox) {
      let { minUnitHeight } = dataRef.current;
      let newHeight = dataRef.current.dragDivHeight;
      let remainder = newHeight % minUnitHeight;
      // console.log("height:", newHeight, " minUnitHeight:", minUnitHeight, " remainder:", remainder);
      if (remainder >= minUnitHeight / 2) {
        newHeight = newHeight - remainder + minUnitHeight;
      } else {
        newHeight = newHeight - remainder;
      }
      dragBox.style.height = newHeight + "px";
      dataRef.current.dragDivHeight = newHeight;
      updateDragTime(event, DragState.UP, DragType.DRAGCREATE, dragBox);
    }
    if (dragBlockBox) {
      // 四分之一格的高度
      const oneFourthHeight = container?.clientHeight / 24 / 4;
      const dragBlockBoxYRemainder = dragBlockBox?.offsetTop % oneFourthHeight;
      // 大于四分之一则往下移 反正则往上移
      let styleTop = 0;
      if (dragBlockBoxYRemainder >= oneFourthHeight / 2) {
        styleTop = dragBlockBox?.offsetTop + (oneFourthHeight - dragBlockBoxYRemainder);
      } else {
        styleTop = dragBlockBox?.offsetTop - dragBlockBoxYRemainder;
      }
      dragBlockBox.style.top = (styleTop > 0 ? styleTop : 0) + "px";
      // 周视图拖拽日程块 如果日程块落在非整周天内 则进行自动调整
      if (dragView === DragViewType.WEEK) {
        const dragBlockBoxXRemainder = (dragBlockBox?.offsetLeft - 65) % dragBlockBox?.offsetWidth;
        // 余大于二分之一则往右移 反之则往左移 减3是因为每个schedule item的宽度都余了3px的宽度
        if (dragBlockBoxXRemainder >= dragBlockBox?.offsetWidth / 2) {
          // 往右移
          dragBlockBox.style.left =
            dragBlockBox?.offsetLeft +
            (dragBlockBox?.offsetWidth - dragBlockBoxXRemainder) -
            3 +
            "px";
        } else {
          // 往左移
          dragBlockBox.style.left = dragBlockBox?.offsetLeft - dragBlockBoxXRemainder - 3 + "px";
        }
      }
      // 拖动计算时间
      updateDragTime(event, DragState.UP, DragType.DRAGBLOCKEDIT, dragBlockBox);
    }
  }
};

export const handleBusyIdleMouseUpFun = (opts: MouseUpProps) => {
  const { event, dataRef, dragView, updateDragTime } = opts;
  const { container, dragDom } = dataRef.current;
  if (dataRef.current.curDragType === DragType.DRAGBORDEREDIT) {
    let { minUnitHeight } = dataRef.current;
    const domReact: any = dragDom?.getBoundingClientRect();
    let newHeight = domReact?.height || 0;

    let remainder = newHeight % minUnitHeight;
    if (remainder >= minUnitHeight / 2) {
      newHeight = newHeight - remainder + minUnitHeight;
    } else {
      newHeight = newHeight - remainder;
    }
    dragDom.style.height = newHeight + "px";
    dataRef.current.dragDivHeight = newHeight;
    updateDragTime(event, DragState.UP, DragType.DRAGBORDEREDIT, dragDom);
  }
  if (dataRef.current.curDragType === DragType.DRAGTIMEBLOCKEDIT) {
    // 四分之一格的高度
    const oneFourthHeight = container?.clientHeight / 24 / 4;
    const dragBlockBoxYRemainder = dragDom?.offsetTop % oneFourthHeight;
    // 大于四分之一则往下移 反正则往上移
    let styleTop = 0;
    if (dragBlockBoxYRemainder >= oneFourthHeight / 2) {
      styleTop = dragDom?.offsetTop + (oneFourthHeight - dragBlockBoxYRemainder);
    } else {
      styleTop = dragDom?.offsetTop - dragBlockBoxYRemainder;
    }
    dragDom.style.top = (styleTop > 0 ? styleTop : 0) + "px";
    // 拖动计算时间
    updateDragTime(event, DragState.UP, DragType.DRAGTIMEBLOCKEDIT, dragDom);
  }

  if (dataRef.current.scrollUpTimer || dataRef.current.scrollDownTimer) {
    clearInterval(dataRef.current.scrollUpTimer);
    clearInterval(dataRef.current.scrollDownTimer);
    dataRef.current.scrollUpTimer = null;
    dataRef.current.scrollDownTimer = null;
  }
  dataRef.current.isMouseDown = false;
  dataRef.current.dragDom = null;
  dataRef.current.curDragType = DragType.DRAGCREATE;
  dataRef.current.curMoveSchedule = null;
  dataRef.current.dragDivHeight = 0;
  dataRef.current.dragBorder = "";
  dataRef.current.dragStartY = 0;
  dataRef.current.dragBorderStartTop = 0;
  dataRef.current.dragBorderStartBottom = 0;
};

export const handleScrollFrameFun = (opts: scrollFrameProps) => {
  const { event, dataRef, scrollRef, updateDragTime } = opts;
  // 显示遮罩层时，底层画布禁止滚动
  let mask = document.getElementById("drag-mask");
  if (mask) {
    scrollRef.current?.scrollTop(dataRef.current.scrollTop);
    return;
  }
  let { minHeight, container, containerHeight, dragStartTop, dragType, dragView } = dataRef.current;
  // 当触发滚轮事件或者拖动滚动出发滚动轴事件 最初的锚点和滚动之后的锚点比较
  // 计算原理 (dataRef.current.mouseY+event.scrollTop-dataRef.current.commonOffsetTop)-dataRef.current.dragStartTop
  let mouseYoffsetOnContainer =
    dataRef.current.mouseY +
    event.scrollTop -
    dataRef.current.commonOffsetTop -
    dataRef.current.dragStartTop;
  // if mouseYoffsetOnContainer >= 0 表示滚动轴向下滚动 滚动距离是mouseYoffsetOnContainer 反之亦然
  let underOrigin = mouseYoffsetOnContainer >= 0;
  if (dataRef.current.isMouseDown) {
    if (dataRef.current.curDragType === DragType.DRAGBLOCKEDIT) {
      // 拖拽块编辑
      let dragBlockBox = document.getElementById("drag-block-box");
      if (dragBlockBox) {
        // 通过scrollTop的变化来实时计算拖动块的位置
        const dragBlockBoxRect = dragBlockBox.getBoundingClientRect();
        let yTop = dataRef.current.mouseY + event.scrollTop - dataRef.current.commonOffsetTop;
        // 如果top超出上边界 则不能在往上拖动 如果bottom超出下边界 则不能在往下拖动
        let styleTop = 0;
        if (dataRef.current.mouseY < dataRef.current.commonOffsetTop) {
          styleTop = event.scrollTop;
        } else if (dataRef.current.mouseY + dragBlockBoxRect.height > window.innerHeight) {
          // 拖到底了
          styleTop =
            window.innerHeight -
            dragBlockBoxRect.height +
            event.scrollTop -
            dataRef.current.commonOffsetTop;
        } else {
          styleTop = yTop;
        }
        dragBlockBox.style.top = (styleTop > 0 ? styleTop : 0) + "px";
      } else {
        // 没有dragBlockBox则创建
        const containerRect = container?.getBoundingClientRect();
        const dragDom: any = dataRef.current.dragDom;
        const newEl = dragDom?.cloneNode(true);
        elStopPropagation(newEl);
        if (dragView === DragViewType.WEEK) {
          newEl.style.width = Math.ceil((containerRect?.width - 65) / 7) + "px";
        } else {
          newEl.style.width = "calc(100% - 65px)";
          newEl.style.left = "65px";
        }
        newEl.style.background = "#4DA6FF";
        newEl.id = "drag-block-box";
        container.appendChild(newEl);
      }
      updateDragTime(event, DragState.MOVE, DragType.DRAGBLOCKEDIT, dragBlockBox);
    } else if (dataRef.current.curDragType === DragType.DRAGCREATE) {
      // 拖拽创建
      let dragBox = document.getElementById("drag-box");
      if (dragBox) {
        if (underOrigin) {
          // 向下滚动
          let newHeight = mouseYoffsetOnContainer;
          newHeight = newHeight <= minHeight ? minHeight : newHeight;
          // 新的高度到底 不能超过底
          if (newHeight + dragStartTop > containerHeight) {
            newHeight = containerHeight - dragStartTop;
          }
          dragBox.style.height = newHeight + "px";
          dataRef.current.dragDivHeight = newHeight;
        } else {
          // 反向向上滚动 minHeight 代表dragBox的最小出始高度
          // 这时mouseYoffsetOnContainer为负值 反向计算dragBox的高度
          let newHeight = minHeight - mouseYoffsetOnContainer;
          newHeight = newHeight <= minHeight ? minHeight : newHeight;
          let maxHeight = dragStartTop + minHeight;
          // 新的高度 最高到顶
          if (newHeight > maxHeight) {
            newHeight = maxHeight;
          }
          dragBox.style.height = newHeight + "px";
          dataRef.current.dragDivHeight = newHeight;
        }
        // 滚动轴滚动方向和拖拽方向相反时触发
        if (underOrigin !== dataRef.current.isUnderOrigin) {
          let newHeight = dataRef.current.dragDivHeight;
          if (underOrigin) {
            dragBox.style.bottom = "";
            dragBox.style.top = dataRef.current.dragStartTop + "px";
            newHeight =
              dataRef.current.mouseY +
              event.scrollTop -
              dataRef.current.commonOffsetTop -
              dataRef.current.dragStartTop;
          } else {
            dragBox.style.top = "";
            dragBox.style.bottom =
              containerHeight - dataRef.current.dragStartTop - minHeight + "px";
            newHeight =
              dataRef.current.dragStartTop -
              dataRef.current.mouseY -
              event.scrollTop +
              dataRef.current.commonOffsetTop;
          }
          newHeight = newHeight <= minHeight ? minHeight : newHeight;
          dragBox.style.height = newHeight + "px";
          dataRef.current.dragDivHeight = newHeight;
        }
      } else {
        // 如果没有dragBox则创建
        let { minHeight } = dataRef.current;
        // 创建div
        let div = document.createElement("div");
        elStopPropagation(div);
        div.style.height = minHeight + "px";
        div.style.top = dataRef.current.dragStartTop + "px";
        div.id = "drag-box";
        if (dragType === DragType.DRAGBLOCKEDIT) {
          div.style.width = "calc(100% - 4px)";
          div.style.left = "2px";
        }
        // 将创建的div添加到容器中
        container.appendChild(div);
        dataRef.current.dragDivHeight = minHeight;
        if (!document.getElementById("drag-silk")) {
          let silk = document.createElement("div");
          silk.id = "drag-silk";
          if (dragType === DragType.DRAGCREATE) {
            container.appendChild(silk);
          } else if (dragType === DragType.DRAGBLOCKEDIT) {
            container.parent.parent.appendChild(silk);
          }
        }
      }
      updateDragTime(event, DragState.MOVE, DragType.DRAGCREATE, dragBox);
    }
  }
  dataRef.current.scrollTop = event.scrollTop;
  dataRef.current.isUnderOrigin = underOrigin;
};
